import DataRoomSubrouterNavigation from './DataRoomSubrouterNavigation.component';

export default DataRoomSubrouterNavigation;